import React from 'react'
import { useLocation } from 'react-router-dom'

import WhatIsPassport from '../../components/WhatIsPassport'

function WhatIsPassportWrapper() {
  const location = useLocation()
  const { displayUrl, stationDisplayName } = (location.state || {}) as {
    displayUrl: string
    stationDisplayName: string
  }

  return (
    <WhatIsPassport
      displayUrl={displayUrl || ''}
      stationDisplayName={stationDisplayName || ''}
    />
  )
}

export default WhatIsPassportWrapper
